import type { SxProps } from "@mui/material"

import { PRIMARY } from "@constants/colors"

const container: SxProps = {
  display: "flex",
  flex: 1
}

const createOne: SxProps = {
  display: "inline",
  color: PRIMARY,
  fontWeight: "bold"
}

export default { container, createOne }
